import { addMonths, endOfMonth, startOfMonth, subMonths } from 'date-fns';
import { EventsFiltersDTO } from '../../../pages/calendar/dto';

export const useMonthCalendar = (filters: EventsFiltersDTO, setFilters: (filters: EventsFiltersDTO) => void) => {

    const changeInterval = (action: 'next' | 'prev' | 'today') => {
        let month = new Date(filters.fromDateTime!);
        let fromDateTime = startOfMonth(month).toISOString()
        let toDateTime = endOfMonth(month).toISOString()
        if (action === 'next') {
            month = addMonths(month, 1);
            fromDateTime = startOfMonth(month).toISOString()
            toDateTime = endOfMonth(month).toISOString()

        } else if (action === 'prev') {
            month = subMonths(month, 1);
            fromDateTime = startOfMonth(month).toISOString()
            toDateTime = endOfMonth(month).toISOString()
        } else {
            month = new Date();
            fromDateTime = startOfMonth(month).toISOString()
            toDateTime = endOfMonth(month).toISOString()
        }
        setFilters({ ...filters, fromDateTime, toDateTime });
    }

    return {
        filters,
        changeInterval
    };
};
